import { GetOutputSchemasParams, TableSchemasList, WorkflowComponentParamType } from '../../types'
import { SelectWorkflowComponent } from './selectcomponent'
import { SINGLE_OUTPUT_NAME } from './singleoutputcomponent'

export abstract class SelectSameSchemaWorkflowComponent extends SelectWorkflowComponent {
  canProvideOutputSchemas(): boolean {
    return true
  }

  _getOutputSchemas({
    workflow,
    params,
    schemas,
    connection,
    componentName
  }: GetOutputSchemasParams): TableSchemasList {
    const tableInputName = this.inputs.find((input) => input.type === WorkflowComponentParamType.InputTable)
      ?.name as string // we assume there is at least one table input, otherwise don't use this class
    const value = params[tableInputName]
    let tablename: string
    if (Array.isArray(value)) {
      tablename = value[0]
    } else {
      tablename = value as string
    }
    const columns = this._getSchemaForTablename(tablename, schemas, connection)
    const fqn = this._getDryRunOutputTableFqn(workflow, params, connection, componentName, SINGLE_OUTPUT_NAME)
    return [
      {
        fqn,
        schema: columns
      }
    ]
  }
}
